export default __webpack_public_path__ + "static/media/prime-crown-icon-gold.98f284ac.svg";